<template>
  <v-app id="inspire">    
    <AppBarComponent/>         
    <v-main class="bg__type1">
      <!-- 조건에 따라 상단 검색영역 전체가 없어지고 히스토리만 노출 -->
      <div class="sch__history__wrapper">
        <v-row class="mt-0 adb__search__history">
          <v-col class="d-flex align-center justify-start sch__history">            
            <router-link :to="{ name: 'query' }">
              <h2 class="history__title" v-html="$t('view.MENU.Search History')">Search History</h2>
            </router-link>
            <div class="sch__text_history">
              <a @click="redirectTo(history.domain, history.formula)" v-for="history in histories" v-bind:key="history.id" v-html="history.formula">egpo</a>
            </div>
            
          </v-col>
        </v-row>
      </div>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0">
          <router-view/>
        </v-col>
      </v-row>
      
    </v-main>
    <FooterComponent/>    
  </v-app>
</template>

<script>
  import AppBarComponent from '@/components/inc/Appbar'  
  import FooterComponent from '@/components/inc/Footer'  
  import { SEARCH_DOMAIN_TYPE_CODE } from '../../models/code'
  import { Search } from '@/models/search'

  export default {
    name: 'CommonRouterSection', 
    components : {
      AppBarComponent,
      FooterComponent
    },
    computed: {
      histories() {
        return this.$store.state.my.histories;
      }
    },
    data: () => ({
      domains: SEARCH_DOMAIN_TYPE_CODE.all,
      search: new Search(SEARCH_DOMAIN_TYPE_CODE.all, {
        FP: null
      }),
    }),
    created () {
      // this.$vuetify.theme.dark = true
    },
    methods : {
      query() {
        this.redirectTo(this.search.domain, this.search.getFormula());
      },
      redirectTo(domain, q) {
        this.redirect({
          name: 'result',
          params: { domain },
          query: { q }
        })
      }

    }
  }
</script>